import React from 'react';
import Select from 'react-select';
import axios from 'axios';

class Rule extends React.Component {
    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);

    }

    getOptions() {
        let ret = [{
            clearableValue:false,
            label:'1 day',
            value:1,
        }];

        for(let i=2;i<=29;i++) {
            ret.push({
                clearableValue:false,
                label:i+' days',
                value:i,
            })
        }

        ret.push({
            clearableValue:false,
            label:'1 month',
            value:30,
        });

        for(let i=2;i<=12;i++) {
            ret.push({
                clearableValue:false,
                label:i+' months',
                value:parseInt(i*30),
            })
        }

        return ret;
    }


    render() {
        return (
            <div>
                <Select
                    disabled={this.props.disabled === true ? true:false}
                    clearable={false}
                    name="form-field-name"
                    value={parseInt(this.props.rule.value)}
                    options={this.getOptions()}
                    onChange={(e) => {this.props.handleRuleChange(this.props.index,'operator',e.value)}}
                />
            </div>
        );
    }


}

export default Rule;




// WEBPACK FOOTER //
// ./containers/segments/Rules/DayPicker.js